import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

const APP_URL = process.env.REACT_APP_APP_URL;
const API_BASE = process.env.REACT_APP_API_BASE_URL;

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';

  const [status, setStatus] = useState('checking'); // checking | valid | invalid | done
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Проверяем токен при загрузке
  useEffect(() => {
    if (!token) { setStatus('invalid'); return; }

    fetch(`${API_BASE}/auth/verify-reset-token?token=${encodeURIComponent(token)}`)
      .then(async r => {
        if (r.ok) {
          const data = await r.json();
          setEmail(data.email);
          setStatus('valid');
        } else {
          const data = await r.json().catch(() => ({}));
          setError(data.error || 'Ссылка недействительна');
          setStatus('invalid');
        }
      })
      .catch(() => {
        setError('Ошибка сети');
        setStatus('invalid');
      });
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirm) return setError('Пароли не совпадают');
    if (password.length < 6) return setError('Пароль должен быть минимум 6 символов');

    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/auth/reset-password`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      });
      const data = await res.json();

      if (res.ok && data.success) {
        setStatus('done');
        setTimeout(() => { window.location.href = `${APP_URL}/login`; }, 3000);
      } else {
        setError(data.error || 'Ошибка сброса пароля');
      }
    } catch {
      setError('Ошибка сети');
    } finally {
      setLoading(false);
    }
  };

  // Проверка токена
  if (status === 'checking') {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  // Токен невалидный
  if (status === 'invalid') {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-md p-8 max-w-md w-full text-center">
          <div className="text-5xl mb-4">🔒</div>
          <h1 className="text-xl font-bold mb-2">Ссылка недействительна</h1>
          <p className="text-gray-500 mb-6">{error || 'Возможно, она истекла или уже была использована.'}</p>
          <Link
            to="/forgot-password"
            className="inline-block bg-blue-600 text-white px-6 py-3 rounded-xl hover:bg-blue-700 transition"
          >
            Запросить новую ссылку
          </Link>
        </div>
      </div>
    );
  }

  // Успех
  if (status === 'done') {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-md p-8 max-w-md w-full text-center">
          <div className="text-5xl mb-4">✅</div>
          <h1 className="text-xl font-bold mb-2">Пароль изменён</h1>
          <p className="text-gray-500 mb-6">
            Через пару секунд перенаправим вас на страницу входа...
          </p>
          <Link to="/login" className="text-blue-600 hover:underline">Войти сейчас →</Link>
        </div>
      </div>
    );
  }

  // Форма нового пароля
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-md p-8 max-w-md w-full">
        <h1 className="text-2xl font-bold text-center mb-2">Новый пароль</h1>
        <p className="text-sm text-gray-500 text-center mb-6">
          Для аккаунта <b>{email}</b>
        </p>

        {error && <div className="bg-red-50 text-red-500 p-3 rounded-xl mb-4">{error}</div>}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Новый пароль</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border rounded-xl px-4 py-2 focus:ring-2 focus:ring-blue-400 focus:outline-none"
              placeholder="••••••••"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Подтвердите пароль</label>
            <input
              type="password"
              required
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              className="w-full border rounded-xl px-4 py-2 focus:ring-2 focus:ring-blue-400 focus:outline-none"
              placeholder="••••••••"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className={`w-full py-3 rounded-xl text-white transition ${
              loading ? 'bg-blue-300 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'
            }`}
          >
            {loading ? 'Сохранение...' : 'Сменить пароль'}
          </button>
        </form>
      </div>
    </div>
  );
}